<template>
  <v-container fluid>
    <v-card flat>
      <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows"
        :footer-props="items_per_page" :must-sort="true" :loading="loading" class="elevation-1">
        <template v-slot:top>
          <hpo-filter :headers="headers" :viewName="viewName" @applyFilter="applyFilter"
            @quickFilter="quickFilter"></hpo-filter>
        </template>
        <template v-slot:item.LoadingDate="{ item }">
          {{ item.LoadingDate | display_date }}
        </template>
        <template v-slot:item.UnloadDate="{ item }">
          {{ item.UnloadDate | display_date }}
        </template>
        <template v-slot:item.Status="{ item }">
          <v-chip :color="item.Status === 1 ? 'orange' : 'green'" dark small>
            {{ item.Status === 1 ? 'Đang xếp / 加载中' : 'Đã hạ hàng / 已卸货' }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon small class="mr-2" :loading="pdfLoadingId === item.ID" @click="exportPdf(item)" title="Xuất PDF tờ khai">
            <v-icon medium>picture_as_pdf</v-icon>
          </v-btn>
          <v-btn v-if="hasEditPermission" icon small class="mr-2" @click="editItem(item)">
            <v-icon medium>edit</v-icon>
          </v-btn>
          <v-btn v-if="hasEditPermission" icon small @click="deleteItem(item.ID)">
            <v-icon medium>delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { sendSuccessNotice, sendErrorNotice } from '@/commons/utils'
import Filtering from "@/components/Filtering"
import configs from "@/configs"
import _ from "lodash"
import { request_header } from '@/commons/hpod'
import createPermissionMixin from "@/mixins/permissionMixin";

export default {
  name: 'CnTruckList',
  mixins: [createPermissionMixin('cn_truck')],
  components: {
    "hpo-filter": Filtering
  },
  data() {
    return {
      pdfLoadingId: null,
      headers: [
        { text: 'Mã xe', value: 'ID', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE["String"] },
        { text: 'Biển số / 车牌', value: 'LicensePlate', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE["String"] },
        { text: 'Ngày bốc / 加载日期', value: 'LoadingDate', filterable: true, dataType: configs.DATA_TYPE["Date"] },
        { text: 'Ngày hạ / 卸货日期', value: 'UnloadDate', filterable: true, dataType: configs.DATA_TYPE["Date"] },
        { text: 'Tổng kg', value: 'TotalWeight' },
        { text: 'Tổng m3', value: 'TotalVolume' },
        { text: 'Tổng kiện', value: 'TotalPackages' },
        { text: 'Tổng mã', value: 'TotalProducts' },
        { text: 'Trạng thái', value: 'Status' },
        { text: 'Thao tác', value: 'actions', sortable: false }
      ],
      viewName: 'cn_truck_list',
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      filterConditions: [],
      quickFilterConditions: []
    }
  },

  computed: {
    ...mapState({
      items: state => state.cnTruck.all.data,
      total_rows: state => state.cnTruck.all.total,
      loading: state => state.cnTruck.loading
    })
  },

  watch: {
    pagination: {
      handler: function () {
        let filterConditions = this.$store.state.commons.filterConditions
        this.filterConditions = filterConditions && filterConditions[this.viewName] ? filterConditions[this.viewName] : []
        this.filter_data()
      },
      deep: true
    }
  },

  mounted() {
    this.$root.$on("REQUEST_CREATE_DATA", this.onCreateData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on('CONFIRMED_REMOVE_DATA', id => {
      this.$store.dispatch('cnTruck/removeDetail', id).then(() => {
        sendSuccessNotice(this, 'Xóa thành công');
        this.filter_data();
      }).catch(error => {
        sendErrorNotice(this, error.message || 'Xóa thất bại');
      });
    });
  },

  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.onCreateData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off('CONFIRMED_REMOVE_DATA');
  },

  methods: {
    onCreateData() {
      this.$router.push('/hang-chinh-ngach/xep-xe/0')
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = _.cloneDeep(configs.PAGINATION)
      this.pagination.sortBy = sortBy
      this.pagination.sortDesc = sortDesc
      this.filterConditions = filterConditions
      this.filter_data()
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions
      this.filter_data()
    },
    filter_data() {
      this.$store.dispatch("cnTruck/getList", {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      })
    },
    deleteItem(id) {
      window.getApp.$emit('REQUEST_DELETE_DATA', id);
    },
    editItem(item) {
      this.$router.push(`/hang-chinh-ngach/xep-xe/${item.ID}`)
    },
    async exportPdf(item) {
      this.pdfLoadingId = item.ID
      try {
        const token = this.$store.state.authentication.token
        const url = `${configs.API}/api/cn-trucks/${item.ID}/export-pdf/`
        const res = await fetch(url, { headers: request_header(token) })
        if (!res.ok) {
          const err = await res.json().catch(() => ({}))
          sendErrorNotice(this, err.reason || 'Xuất PDF thất bại')
          return
        }
        const blob = await res.blob()
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `ToKhai_${item.TruckCode || item.ID}.pdf`
        link.click()
        URL.revokeObjectURL(link.href)
      } catch (e) {
        sendErrorNotice(this, 'Lỗi khi xuất PDF: ' + e.message)
      } finally {
        this.pdfLoadingId = null
      }
    }
  }
}
</script>
